/** Shared keys for the Home Next Steps checklist. */

export enum NextStepsKey {
  SETUP_INSTITUTION = 'setup_institution',
  CREATE_SPACE = 'create_space',
  ADD_BRANDING = 'add_branding',
  INVITE_USERS = 'invite_users',
  RUN_FIRST_CLASS = 'run_first_class'
}
